import {authClient, Session} from '@/shared/integrations/better-auth/client'
import {queryOptions, useSuspenseQuery} from '@tanstack/react-query'
import {User} from 'better-auth'

export const authQueryOptions = queryOptions({
  queryKey: ['session-data'],
  queryFn: async () => {
    const {data, error} = await authClient.getSession()
    if (error) throw error

    const user = data?.user as User | undefined
    const session = data?.session as Session | undefined

    if (!user || !session) return null

    return {user, session}
  },
  refetchOnWindowFocus: true,
  refetchInterval: 5 * 60 * 1000,
  refetchIntervalInBackground: true,
})

export function useAuth() {
  const {data, ...rest} = useSuspenseQuery({
    ...authQueryOptions,
  })

  return {...rest, auth: {user: data?.user, session: data?.session}}
}
